import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const roadguardlogsConfig: TSPConfig = {
  key: 'roadguardlogs',
  name: 'Road Guard Logs',
  imageName: 'RoadGuardLogs',
  category: TSPCategory.CUSTOM,
  helpText: 'Please input the Company ID from your Road Guard Logs profile.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter Company ID',
          name: 'authorizationcode',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default roadguardlogsConfig;
